import httpService from "../../Service/httpService";

const controller = "Horarios";

export const getHorariosServicio = async (id, idServicio, idMedico, f1, f2, filtro) => {
  const res = await httpService.get(
    `/${controller}/getHorariosServicio/${id}/${idServicio}/${idMedico}/${f1}/${f2}/${filtro}`
  );
  return res.data;
};

export const getCatServicios = async (id) => {
  const res = await httpService.get(
    `/${controller}/getCatServicios/${id}`
  );
  return res.data;
};

export const getEspacios = async (id, idServicio) => {
  const res = await httpService.get(
    `/${controller}/getEspacios/${id}/${idServicio}`
  );
  return res.data;
};


export const saveHorario = async (data) => {
  //   const userData = getDecodedToken();
  const res = await httpService.post(`/${controller}/saveHorario`, {
    ...data,
  });
  return res;
};

export const cancelHorario = async (data) => {
  //   const userData = getDecodedToken();
  const res = await httpService.post(`/${controller}/cancelHorario`, {
    ...data,
  });
  return res;
};

export const eliminaHorarios = async (data) => {
  //   const userData = getDecodedToken();
  const res = await httpService.post(`/${controller}/eliminaHorarios`, {
    ...data,
  });
  return res;
};

export const saveEspacio = async (data) => {
  //   const userData = getDecodedToken();
  const res = await httpService.post(`/${controller}/saveEspacio`, {
    ...data,
  });
  return res;
};


